class MiniCart {
  constructor(opts = {cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null }) {
    const _defaults = {cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null };
    

    if (!opts.id) {
      let id = '';
      for (let x = 0; x < 12; x++) id += '' + Math.floor(Math.random() * 10); 
      this.id = id;
    }
    this._selectors0 = {
      count: 'data-cart-count',
      items: 'data-cart-items',
      item: 'data-cart-item',
      price: 'data-cart-total-price',
      quantityInput: 'data-cart-quantity',
      quantityChange: 'data-cart-quantity-change',
      close: `data-cart-close="${this.id}"`,
      discount: 'data-cart-discount',
    };
    this._selectors = {
      count: '[data-cart-count]',
      items: '[data-cart-items]',
      item: '[data-cart-item]',
      itemIdAttribute: 'data-cart-item',
      price: '[data-cart-total-price]',
      quantityInput: '[data-cart-quantity]',
      quantityChange: '[data-cart-quantity-change]',
      quantityChangeAttribute: 'data-cart-quantity-change',
      close: `[data-cart-close="${this.id}"]`,
      discount: '[data-cart-discount]',
    };
    this.classes = {
      open: opts.cartClass || _defaults.cartClass,
      body: opts.bodyClass || _defaults.bodyClass
    };
    this.formatPriceOptions = opts.formatOptions || _defaults.formatOptions;
    if (!opts.template || !typeof opts.template == 'Function') {
      this.renderFn = (cart, ctx) => {
       
  
        
      return `
<div class="hc-cart-overlay" data-cart-overlay ${ctx.selectors.close}></div>
<div class="hc-cart-contoiner" id="${cart.id}" data-cart-container>
<div class="hc-cart-header">
<div class="hc-close-btn ad ad-times-r" ${ctx.selectors.close}>X</div>
<div class="hc-cart-title"><p>Cart</p></div>
<div class="hc-cart-count" ><p><span data-cart-count>${ctx.count}</span> item(s) in your cart</p></div>
</div>
<div class="hc-cart-items" data-cart-items>
${ctx.items.map(item => `<div ${ctx.selectors.item}=${item.id} class="hc-cart-line-items">
<a class="hc-image-container" href="${ item.url }">
<img src="${ctx.imageFilter(item.image)}" />
</a>
<div class="hc-item-description">
<a class="hc-item-title" href="${ item.url }">${item.product_title}</a>
${ item.variant_title && `<div class="hc-item-variant">${item.variant_title}</div>` || ""}
<div class="hc-item-price"><span>${ theme.Currency.formatMoney(item.final_line_price, ctx.formatPriceOptions)}</span>
${ (item.discounts.length > 0)?`<span class="hc-original-price">${ theme.Currency.formatMoney(item.price, ctx.formatPriceOptions )}</span>`:``}
<p>${ (item.discounts.length > 0)?`${ctx.showDiscounts(item.discounts)}`:``}</p>
</div>
<div class="hc-item-quantity">
<div class="hc-item-quantity-negative hc-clickable" ${ctx.selectors.quantityChange}="-1">-</div>
<input ${ctx.selectors.quantityInput} type="number" min="1" value="${item.quantity}" />
<div class="hc-item-quantity-positive hc-clickable" ${ctx.selectors.quantityChange}="1">+</div>
<div class="spacer"></div>
<div class="hc-remove hc-clickable" ${ctx.selectors.quantityChange}="0">Remove</div>
</div>
</div>
</div>`).join('')}
</div>
<div class="hc-cart-subtotal">
  <span>Total: </span>
  <span class="amount-price" ${ctx.selectors.price}>${ theme.Currency.formatMoney(ctx.price, ctx.formatPriceOptions) }</span>
</div>
<div ${ctx.selectors.discount}>
  ${ (ctx.cart.total_discount > 0)?`${ctx.showSavedMoney(ctx.cart.total_discount)}`:``}


</div>
  <div class="buttons">
  <!-- <a class="btn checkout" href="/checkout">Checkout</a> -->
  <a class="btn btn--secondary" href="/cart">View Cart</a>
  
  </div>
</div>
`;
    }
    } else { 
      this.renderFn = opts.template;
    }
    
    // Events containers
    this._updates = [];
  }
  
  // Update cart function
  update() {
    if (!this.exists) {
      this.implement();
    }
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    const cartPromise = fetch(root_url + '/cart.js').then(res => res.json());
    return this._updateCartContent(cartPromise);
    
  }
  
  _updateCartContent(cartPromise) {
    return cartPromise
    .then(cart => {
      console.log('[HC]', cart); 

      return ({
          content: this._render(cart),
            cart: cart
    });
               
    }
    
      )
    .then(({content, cart}) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");
      return {
        content: doc.querySelector('[data-cart-container]'),
        cart,
        
      };

    })
    .then((res) => { this._fireUpdateEvent(res.cart); return res; })
    .then(({content, cart}) => this.refresh(content, cart))
    .then( () => bannerPriceUpdate())

    
  }
  
  _fireUpdateEvent(cart) {
    for (const cb of this._updates) {
      cb(cart);
    }
  }
  // Refresh cart content with a new content
  refresh(content) {
    console.log(content);
    console.log(this._el.querySelector(this._selectors.price).innerHTML);
    if (this._el.querySelector(this._selectors.count)) this._el.querySelector(this._selectors.count).innerHTML = content.querySelector(this._selectors.count).innerHTML;
    if (this._el.querySelector(this._selectors.items)) this._el.querySelector(this._selectors.items).innerHTML = content.querySelector(this._selectors.items).innerHTML;
    if (this._el.querySelector(this._selectors.price)) this._el.querySelector(this._selectors.price).innerHTML = content.querySelector(this._selectors.price).innerHTML;
    if (this._el.querySelector(this._selectors.discount)) this._el.querySelector(this._selectors.discount).innerHTML = content.querySelector(this._selectors.discount).innerHTML;
    return content;
  }
  
  // Open cart even if not implemented
  open() {
    if (!this.exists) {
      this.implement();
    }
    this._el.classList.add(this.classes.open);
    document.querySelector('body').classList.add(this.classes.body);

  }
  close() {
    this._el.classList.remove(this.classes.open);
    document.querySelector('body').classList.remove(this.classes.body);

  }
  updateQty(id, qty) {
    const cartPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates: {[id]: qty}}),
    }).then(cart => cart.json());

    return this._updateCartContent(cartPromise);

  }
  //theme.Currency.formatMoney(variant.price, theme.moneyFormat
  _render(cart) {
    return this.renderFn(this, {
      cart,
      items: cart.items,
      count: cart.item_count,
      price: cart.total_price,
      selectors: this._selectors0, 
      formatPriceOptions: theme.moneyFormat,
      imageFilter:this.imageFilter,
      showDiscounts:this.showDiscounts,
      showSavedMoney:this.showSavedMoney,
    });
    alert(cart.total_price);
  }
  implement() {
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    fetch(root_url + '/cart.js')
    .then(res => res.json())
    .then(cart => this._render(cart))
    .then(content => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");
        document.querySelector('body').append(doc.querySelector('[data-cart-overlay]'));
        return doc.querySelector('[data-cart-container]');
    })
    .then(el => {
      document.querySelector('body').append(el);
      this._el = el;
      document.querySelector('body').addEventListener('change', (e) => {
        console.log('[HC] Test');
        if (e.target.matches(this._selectors.quantityInput)) {
          console.log('[HC] Test2');
          this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), e.target.value)
        }
      });
      document.querySelector('body').addEventListener('click', (e) => {
        if (e.target.matches(this._selectors.quantityInput)) {
            e.preventDefault();
            e.stopPropagation();
          return false;
        }
        if (e.target.matches(this._selectors.quantityChange)) {
          const val = Number(e.target.getAttribute(this._selectors.quantityChangeAttribute));
          const inp = e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput);
          inp.value = val == 0 ? 0 : Number(e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput).value) + Number(val);
          this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), inp.value)
          e.preventDefault();
            e.stopPropagation();
          return false;
        }
        if (e.target.matches(this._selectors.close)) {
          this.close()
        }
      });
      this.exists = true;
    });
    
  }
  // Events 
  onUpdate(cb) {
    this._updates.push(cb);
  }

  addProduct(formOrId, qty) {
    const vals = {};
    if (qty && (typeof formOrId === "string")) {
      vals.id = formOrId;
      vals.quantity = qty;
    } else {
      const form = formOrId;
      form.querySelectorAll("textarea, select, input").forEach(el => el.getAttribute('name') && el.value && (vals[el.getAttribute('name')] = el.value))
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(vals),
    })
    .then(() => this.update())
    .then(() => bannerPriceUpdate())
    .then(() => this.open());
    

  }
  imageFilter(image){
    let checkExtension = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi;
    let extension = image.match(checkExtension)
    return image.replace(extension,`_150x${extension}`)
  }
  showDiscounts(discounts){
    return discounts.map( discount => discount.title )
  }
  showSavedMoney(money){
    let template = `
    <div class="hc-saved-money">
      You're saving ${ theme.Currency.formatMoney(money, this.formatPriceOptions) }
    </div>`;
    return template;
  }  
  
}